import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SizesWithStock } from 'src/app/models/types/Product/Stock.type';
import { PdpService } from '../pdp.service';

@Component({
  selector: 'app-size-selector',
  imports: [],
  templateUrl: './size-selector.component.html',
  styleUrl: './size-selector.component.scss'
})
export class SizeSelectorComponent implements OnChanges {

  @Input('sapCode') sapCode!: string;
  @Input('sizes') sizes!: SizesWithStock;
  @Input('loading') loading!: boolean;

  @Output('handleSelectSize') handleSelectSize: EventEmitter<string> = new EventEmitter();

  constructor(public pdpService: PdpService) { }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('sizes', this.sapCode);
    // this.pdpService.isLightSize(this.sapCode);
  }

}
